import { useState } from 'react';
import { Box } from 'reflexbox';

import { useLocalize } from '@treams/treams-hooks';
import { EvaluationFormFragment } from '@treams/treams-network';
import { Accordion, Checkbox } from '@treams/treams-ui';

import { SelectConversationTypeCard as InfoCard } from './SelectConversationTypeCard';

type Props = {
	forms: EvaluationFormFragment[];
	selected?: EvaluationFormFragment | undefined;
	onSave: (form: EvaluationFormFragment) => void;
};

export const SelectConversationAccordionGroup = ({ forms, selected, onSave }: Props) => {
	const { localize } = useLocalize();

	const [openIndex, setOpenIndex] = useState<number | null>(null);

	const handleToggle = (index: number) => {
		setOpenIndex(openIndex === index ? null : index);
	};

	return (
		<Box p={3}>
			{forms.map((form, index) => (
				<Box key={form.id} my={2}>
					<Accordion
						index={index}
						isExpanded={openIndex === index}
						title={localize(form.title).text}
						onClick={() => {
							handleToggle(index);
							onSave(form);
						}}
						checkbox={<Checkbox checked={openIndex === index} />}
					>
						{selected && <InfoCard {...selected} />}
					</Accordion>
				</Box>
			))}
		</Box>
	);
};
